import Vue from 'vue'
import router from './router'
import Antd from 'ant-design-vue'

import 'ant-design-vue/dist/antd.css'
import '@/styles/basic.scss'

Vue.use(Antd)
Vue.config.productionTip = false

new Vue({
  router,
}).$mount('#app')
